<template>
  <SearchSelect
    v-model="selectedId"
    :mode="SelectMode.SITE"
    :filters="siteFilters"
    :placeholder="t('global.all')"
    hide-label
    no-min-with
    hide-jump-to-origin
  />
</template>

<script setup lang="ts">
import { computed, ref, watch } from "vue";
import { useTranslation } from "@/language/translation";
import { useAccessRights } from "@/functions/useAccessRights";
import SearchSelect from "@/components/shared/searchSelects/SearchSelect.vue";
import { SelectMode } from "@/components/shared/searchSelects/SelectDefinitions";
import SiteFilter from "../filterImplementations/SiteFilter";
import { FilterUIProps } from "../FilterTypes";

defineProps(FilterUIProps);
const emit = defineEmits<{ "update:siteId": [siteId: number | undefined] }>();
const { t } = useTranslation();
const accessRights = useAccessRights();
const selectedId = ref<number>();
const siteFilters = computed(() => {
  const siteIds = accessRights.siteIdsWithRight("sqdc.read");
  return siteIds == null ? {} : { siteIds: siteIds.length > 0 ? siteIds : [-1] };
});

watch(selectedId, (siteId) => emit("update:siteId", siteId));

function getFilter() {
  return selectedId.value == null ? null : new SiteFilter(selectedId.value);
}
function applyFilter(filter: SiteFilter) {
  selectedId.value = filter.siteId;
}
defineExpose({ getFilter, applyFilter });
</script>
